import { ApiChatbotFeedbackResponseInterface } from '../interfaces/api';
import { ChatbotFeedbackInterface } from '../interfaces/chatbot-feedback.interface';

export const mapFeedbackResponse = ({
    result,
    Message
}: ApiChatbotFeedbackResponseInterface): ChatbotFeedbackInterface => ({
    success: result?.toLowerCase() === 'ok',
    message: Message
});
